function parallax_image() {

    const speed = 0.25;
    const scale = 2;
    const windowHeight = window.innerHeight;
    const scrollAmount = windowHeight * scale * speed;
    const scrollY = window.scrollY;

    document.querySelectorAll('.parallax').forEach(container => {
        const img = container.querySelector('img');
        const containerHeight = container.offsetHeight;
        const containerTop = container.getBoundingClientRect().top + scrollY;
        const imageHeight = Math.ceil(containerHeight + scrollAmount);
        let imageYPosition = (img.hasAttribute('data-y-position')) ? img.dataset.yPosition : 50;

        let scrollOffset = 0;
        let imageTop = 0;

        if (scrollY + windowHeight > containerTop && scrollY < containerTop + containerHeight) {
            scrollOffset = Math.round((scrollY - containerTop) * speed);
        }

        imageTop = Math.floor(scrollAmount * (imageYPosition / 100) * -1);

        if ((scrollAmount + (imageTop + scrollOffset)) < 0) {
            scrollOffset = (scrollAmount * -1) - imageTop;
        }

        img.style.height = imageHeight +'px';
        img.style.top = imageTop +'px';
        img.style.transform = 'translate3d(0,' + scrollOffset + 'px,0)';
    });

}

parallax_image();

window.addEventListener('resize', parallax_image);
window.addEventListener('scroll', parallax_image);